export default {"src":"/_next/static/media/pair-2.fd335b9e.svg","height":309,"width":510,"blurWidth":0,"blurHeight":0};